import { SessionHelper } from "app/helpers/sessionHelper";
import BetDrawerLogic from "app/logic/betDrawerLogic";
import { BetSlipType } from "app/types/betSlipType";
import { PureComponent } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { IconBetDrawerEmpty } from "../../../../../../../../components/Icon/Icon";
import BetSlipEvent from "./components/BetSlipEvent/BetSlipEvent";

type Props = {
  betSlipList: BetSlipType[];
  numberOfMultiplesNotAvailable: number;
};

class BetSlipList extends PureComponent<Props> {
  render(): React.ReactNode {
    const { betSlipList, numberOfMultiplesNotAvailable } = this.props;
    const betSlipsGroupedByEvent =
      BetDrawerLogic.groupBetSlipListByEvents(betSlipList);

    return (
      <div className="bet-slip-list">
        {numberOfMultiplesNotAvailable >= 1 && betSlipList.length > 1 && (
          <div
            className={`bet-drawer__no-multiples-available ${
              SessionHelper.isAsianRouteAndSessionView() ? "asia" : "europe"
            }`}
          >
            <FormattedMessage tagName="span" id="bets-betslip-multiples-note" />
          </div>
        )}
        {betSlipList.length > 0 ? (
          <div className="bet-drawer__list">
            {betSlipsGroupedByEvent.map((betslipgroup, index) => {
              if (betslipgroup?.length > 0) {
                return <BetSlipEvent betSlipList={betslipgroup} key={index} />;
              } else {
                return null;
              }
            })}
          </div>
        ) : (
          <div className="bet-drawer__empty-list">
            <IconBetDrawerEmpty />
            <span className="bet-drawer__empty-list__text">
              <FormattedMessage tagName="span" id="bets-empty-betslip-text" />
            </span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  numberOfMultiplesNotAvailable:
    state.betSlipListModel.numberOfMultiplesNotAvailable,
});

const mapDispatchToProps = (dispatch: any) => {};

export default connect(mapStateToProps, null)(injectIntl(BetSlipList)) as any;
